import { gql } from '@apollo/client/core'

// The waves a tracker wave de-duplicates against, stored on its questionnaire.
export const WAVE_EXCLUSIONS = gql`
  query waveExclusions($projectId: ID!, $waveId: ID!) {
    draftQuestionnaire: draftQuestionnaireV2(
      projectId: $projectId
      waveId: $waveId
    ) {
      questionnaireId
      excludedWaveIds
    }
  }
`
